import React, {Component} from 'react'
import LoadingSpinner from '../../common/spinner/loading.component.jsx'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import EventBus from '../../common/EventBus.js'
import $ from 'jquery'
import TemplateHeader from "../../common/template/header.component.jsx"
import WorkOrderReceiptItems from "./section/items.component.jsx"

class WorkOrderReceiptPdf extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            receipt: null,
            options: [],
        }
        this.openPdf = this.openPdf.bind(this)
    }

    componentDidMount() {
        $('body').css('background-color', 'white')
        AppContext.getApiClient().get('/work-order-receipts/' + this.props.match.params.hash).then(res => {
            EventBus.dispatch(EventBus.TopicLocaleChange, {
                locale: res.attributes.variables.global.language,
            })
            this.setState({
                receipt: res.attributes.variables
            }, this.openPdf)
        })
    }

    openPdf() {
        const element = document.getElementById('pdf')
        // html2pdf(element, {
        //     margin:       .5,
        //     filename:     this.state.receipt.workOrder.reference + '.pdf',
        //     image:        { type: 'jpeg', quality: 1 },
        //     html2canvas:  { dpi: 192, letterRendering: true},
        //     jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
        // })
    }

    render() {
        if (!this.state.receipt) {
            return <LoadingSpinner marginTop="20px" />
        }

        return <div id="pdf">
            <div className="row final-proposal">
                <TemplateHeader value={this.state.receipt} isPdf={true} />
                <WorkOrderReceiptItems value={this.state.receipt} isPdf={true} />
            </div>
        </div>
    }

}

export default WorkOrderReceiptPdf





// WEBPACK FOOTER //
// ./src/workorder/receipt/pdf.component.jsx